module.exports = __webpack_public_path__ + "static/media/08_DSC0835.af9ef3ba.jpg";